import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import {Server, ProductsListsContext, ModalHelper, AlertModal, helper}  from "./../app.js"; 

export default class TraySelecter extends PureComponent 
{
    static contextType = ProductsListsContext;        
    quantity = 0;
    trays = {};
    modal = null;
    
    constructor (props)
    {
        super(props);

        const hasTray = !helper.isNotObjectOrEmpty(this.props.tray),
            {width = 0, height = 0} = this.props.filter;

        this.state = {
            trays: {},
            id: hasTray ? this.props.tray.id : '',            
            width,
            height,
            width_list: [], 
            height_list: [],
            length: 0,
            loading: false,
            alert_message: ''
        };

        this.quantity = hasTray ? this.props.tray.quantity : 0;
        this.state.length = hasTray ? this.quantity * this.props.tray.length : 0;

        this.modal = new ModalHelper(this);
        
        this.selectTray = this.selectTray.bind(this);
        this.setWidth = this.setWidth.bind(this);
        this.setHeight = this.setHeight.bind(this);
        this.setLength = this.setLength.bind(this);
        this.roundLength = this.roundLength.bind(this);
        this.modal.showTrayChangeWarning = this.modal.showTrayChangeWarning.bind(this.modal);
    }
    get tray ()
    {
        const id = this.state.id;
        let tray = null;

        if (id && id in this.state.trays)
        {
            tray = this.state.trays[id];
        }
        return tray;
    }
    loadTrays ()
    {
        const {type, perforated = null} = this.props.filter,        
            queryParams = {tray_type: type};

        if (type)    
        {
            this.setState({loading: true});

            if (null !== perforated) queryParams.is_perforated = perforated;            

            Server.instance
                .query('get_trays', queryParams)
                .then((recievedTrays) =>
                {
                    const trays = helper.setStateWithRecievedItems(this, 'trays', recievedTrays),
                        width_list = helper.unique(Object.keys(trays).map(i => trays[i].width).filter(value => value > 0).sort(helper.sortNatural)),
                        height_list = helper.unique(Object.keys(trays).map(i => trays[i].height).filter(value => value > 0).sort(helper.sortNatural));

                    this.trays = trays;

                    this.setState({width_list, height_list});
                })
                .catch(e => this.setState({trays: {}, loading: false}));
        }        
    }
    selectTray (e)
    {
        const id = e.target.value,
            newTray = id ? helper.copyObject(this.state.trays[id]) : null;

        this.setState({id, length: 0});
        this.quantity = 0;

        if (!helper.isNotObjectOrEmpty(newTray))
        {
            this.props.on_select(newTray, 'tray');
        } 
        else
        {
            this.props.on_select(null, 'tray');
        }
    }/*
    processSizes (trays = null)
    {
        if (helper.isNotObjectOrEmpty()) trays = this.state.trays;

        const width_list = helper.unique(Object.keys(trays).map(i => trays[i].width).filter(value => value > 0).sort(helper.sortNatural)),
            height_list = helper.unique(Object.keys(trays).map(i => trays[i].height).filter(value => value > 0).sort(helper.sortNatural));

        this.setState({width_list, height_list});
    }*/
    setWidth (e)
    {
        const trays = {},
            width = e.target.value;
        
        if (!width)
        {
            Object.values(this.trays)
                    .filter(tray => !this.state.height || this.state.height == tray.height)
                    .forEach(tray => 
                    {
                        trays[tray.id] = tray;
                    });

            this.setState({trays, width: ''});
        }
        else
        {
            Object.values(this.trays)
                    .filter(tray => width == tray.width && (!this.state.height || this.state.height == tray.height))
                    .forEach(tray => 
                    {
                        trays[tray.id] = tray;
                    });

            this.quantity = 0;            
            this.setState({trays, width, id: '', length: 0});
            this.props.on_select(null, 'tray');
        }
    }
    setHeight (e)
    {
        const height = e.target.value;
        
        if (!height)
        {
            const trays = {};
            
            Object.values(this.trays)
                    .filter(tray => !this.state.width || this.state.width == tray.width)
                    .forEach(tray => 
                    {
                        trays[tray.id] = tray;
                    });
            
            this.setState({trays, height: ''});
        }
        else
        {
            const trays = {};
            
            Object.values(this.trays)
                    .filter(tray => height == tray.height && (!this.state.width || this.state.width == tray.width))
                    .forEach(tray => 
                    {
                        trays[tray.id] = tray;
                    });

            this.quantity = 0;            
            this.setState({trays, height, id: '', length: 0});
            this.props.on_select(null, 'tray');
        }
    }
    setLength (e)
    {
        const tray = helper.copyObject(this.tray);

        if (!helper.isNotObjectOrEmpty(tray))
        {
            let length = e.target.value;
            
            if ('' !== length)
            {
                length = parseInt(length);
                if (isNaN(length) || length < 0)
                {
                    this.setState({alert_message: 'Некорректное значение длины лотка'});
                }
                else if (!length)
                {
                    this.setState({alert_message: 'Не задана длина лотка'});
                }
                else 
                {
                    length*=1000;
                    
                    this.setState({length});

                    this.quantity = tray.quantity = Math.ceil(length / tray.length);

                    this.props.on_select(tray, 'tray');
                }
            }
            else
                this.setState({length});
        }
    }
    roundLength ()
    {
        const tray = this.tray;

        if (tray)
        {
            const length = tray.length * this.quantity;
            this.setState({length}); 
        }
    }
    componentDidMount() 
    {
        this.loadTrays();
    }
    render() 
    {
        const hasTray = !helper.isNotObjectOrEmpty(this.tray),
            width = this.state.width ? this.state.width : '',            
            height = this.state.height ? this.state.height : '',

            widthList = this.state.width_list.map(width => <option key={width} value={width}>{width}</option>),
            heightList = this.state.height_list.map(height => <option key={height} value={height}>{height}</option>),
            traysList = Object.keys(this.state.trays).map(id => <option key={id} value={id}>{'articul' == this.context ? this.state.trays[id].articul : this.state.trays[id].name}</option>);

        widthList.unshift(<option key="none" value="">Ширина, мм</option>),
        heightList.unshift(<option key="none" value="">Высота, мм</option>),
        traysList.unshift(<option key="none" value="">Лоток не выбран</option>);

        let length = this.state.length ? this.state.length : '';
        if (length)
        {
            length = (length / 1000).toFixed(2)*1;
        }

        return (<>    
            <Form.Row>
                <Form.Group as={Col} md={3}>
                    <Form.Label className={!this.props.filter.type ? 'text-muted' : ''}>Ширина лотка,&nbsp;мм:</Form.Label>
                    <Form.Control onChange={this.setWidth} value={width} disabled={!this.props.filter.type} as="select" custom>
                        {widthList}
                    </Form.Control> 
                </Form.Group>
                <Form.Group as={Col} md={3}>
                    <Form.Label className={!this.props.filter.type ? 'text-muted' : ''}>Высота лотка,&nbsp;мм:</Form.Label>
                    <Form.Control onChange={this.setHeight} value={height} disabled={!this.props.filter.type} as="select" custom>
                        {heightList}
                    </Form.Control>
                </Form.Group>
                <Form.Group as={Col} md={6}>
                    <Form.Label className={!this.props.filter.type ? 'text-muted' : ''}>Лоток:{this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}</Form.Label>
                    <Form.Control onChange={this.selectTray} value={this.state.id} disabled={!this.props.filter.type} onClick={this.modal.showTrayChangeWarning} as="select" custom>
                        {traysList}
                    </Form.Control>
                </Form.Group>
            </Form.Row>
            <Form.Group>
                <Form.Label className={!this.props.filter.type ? 'text-muted' : ''}>Длина фрагмента лотка,&nbsp;м:</Form.Label>
                <Form.Row>
                    <Col md={7}>
                        <Form.Control onChange={this.setLength} onBlur={this.roundLength} onClick={this.modal.showProjectChangeWarning} value={length} disabled={!hasTray} type="text" placeholder="Длина фрагмента, м" />
                    </Col>
                    <Col md={5}>
                        <Form.Text muted>Округление до ближайшего кратного длине лотка</Form.Text>
                    </Col>
                </Form.Row>
            </Form.Group>
            <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>);
    }
}